export function wrapBiWithUpdateDefaults(factory, logger) {
    var updateDefaults = function updateDefaults(params) {
        return factory.updateDefaults(params);
    };
    Object.defineProperty(logger, 'updateDefaults', {
        value: updateDefaults,
    });
    return logger;
}
//# sourceMappingURL=wrapBiWithUpdateDefaults.js.map